import BackofficeEntityItemsBase from './BackofficeEntityItemsBase';

export default class BackofficeEntityOptionsIndex extends BackofficeEntityItemsBase {
  constructor() {
    super('option');
  }

  toggle_permissions(id, value, entityId, isEntityItem) {
    let data = {};
    let field_value = {};
    field_value["for_sale"] = value
    data[`entity_${this.type}`] = field_value
    data[`is_entity_${this.type}`] = isEntityItem

    let ajax_data = {
      url: `/entities/${entityId}/entity_${this.type}s/${id}/ajax_update`,
      data: data,
      method: "put"
    }

    $.ajax(ajax_data)
  }
}